import React, { Component } from 'react';
import MexicoFooter from './mexico';
import GrFooter from './grfooter';

import './style.css';


class Footer extends Component {
    render() {
        return (
            <footer className="chackastronow-footer">
                { this.props.country === 'es' || this.props.country === 'mx'  && <MexicoFooter /> }
                { this.props.country === 'gr' && <GrFooter/> }
            </footer>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/checkastronow/components/footer/footer.js